import BackgroundImage from "@pathwright/ui/src/components/background/BackgroundImage"
import ConnectStores from "lib/core/store/components/ConnectStores"
import React from "react"
import FacilitatorContainer from "../facilitator/FacilitatorContainer"
import "./ResourceHeader.css"
import ResourceHeaderDash from "./dash/ResourceHeaderDash"
import ResourceHeaderDisplay from "./display/ResourceHeaderDisplay"
import ResourceHeaderTabs from "./tabs/ResourceHeaderTabs"

class ResourceHeader extends React.Component {
  render() {
    const {
      mode,
      resource,
      offering,
      section,
      communityArea,
      registration,
      permissions,
      toPerformance,
      displayType,
      baseURL,
      manageURL,
      downloadCertificateUrl,
      progress,
      discussionEnabled
    } = this.props

    if (!resource || !offering) return null

    return (
      <div className="ResourceHeader">
        <div className="ResourceHeader__Container">
          <BackgroundImage
            className="ResourceHeader__Background"
            overlay={resource.background_overlay}
            image={
              resource.background_type === 5
                ? resource.background_image_blurred_cdn
                : resource.background_image
            }
          />
          <div className="ResourceHeader__Main">
            <div>
              {section === "about" ? (
                <ResourceHeaderDisplay
                  downloadCertificateUrl={downloadCertificateUrl}
                />
              ) : (
                <>
                  <ResourceHeaderDash
                    mode={mode}
                    resource={resource}
                    offering={offering}
                    permissions={permissions}
                    toPerformance={toPerformance}
                    downloadCertificateUrl={downloadCertificateUrl}
                    progress={progress}
                    section={section}
                    communityArea={communityArea}
                  />
                  <FacilitatorContainer inverted />
                </>
              )}
            </div>
          </div>
          <ResourceHeaderTabs
            baseURL={baseURL}
            section={section}
            registration={registration}
            discussionEnabled={discussionEnabled}
          />
        </div>
      </div>
    )
  }
}

ResourceHeader.displayName = "ResourceHeader"

const mapStateToProps = function (state, ownProps) {
  const { resource, offering, registration, section } =
    state.resourceStore.state
  const { mode, progress } = state.pathStore.state
  const { getAbsoluteURL } = state.navigationStore.request

  const permissions = state.resourceStore.request.permissions()
  const discussionEnabled = state.resourceStore.request.discussionEnabled()

  let baseURL = ""
  let manageURL = ""
  let toPerformance = ""
  let downloadCertificateUrl = ""
  let displayType = "Course"
  let displayAuthors = []

  if (resource) {
    baseURL = `/library/${resource.slug}/`
    manageURL = `/manage/resource/${resource.id}/`
    toPerformance = `${baseURL}performance/`
    if (offering?.id) baseURL += `${offering.id}/`
    // TODO: do this in the model
    if (resource.resource_type === 30) displayType = "Collection"
    if (resource.resource_type === 20) displayType = "Lesson"
    if (registration?.certificate_download_url) {
      downloadCertificateUrl = getAbsoluteURL(
        registration.certificate_download_url
      )
    }

    // In some cases, resource.authors could be undefined.
    if (resource.authors) {
      displayAuthors = resource.authors.map(
        (author) => `${author.first_name} ${author.last_name}`
      )
    }
  }

  const props = _.assign(
    {},
    {
      resource,
      section,
      registration,
      permissions,
      manageURL,
      displayAuthors,
      displayType,
      toPerformance,
      baseURL,
      offering,
      mode,
      downloadCertificateUrl,
      progress,
      discussionEnabled
    },
    ownProps
  )
  return props
}

const connectStores = [
  {
    store: "resource",
    watch: ["resource", "offering", "registration", "section"]
  },
  { store: "path", watch: ["mode", "progress"] },
  { store: "navigation", watch: ["request"] }
]

export default ConnectStores(ResourceHeader, connectStores, {}, mapStateToProps)
